import EventBus from '@/event-bus';

import displayAdaptable from '@/mixins/displayAdaptable';

export default {
  mixins: [displayAdaptable],

  data() {
    return {
      mobileDialogOpen: false,
      mobileDialogUsageCount: 0,
    };
  },

  mounted() {
    if (this.isMobile()) {
      EventBus.$on('mobile-dialog-open', () => {
        this.mobileDialogOpen = true;
        this.mobileDialogUsageCount++;
      });

      EventBus.$on('mobile-dialog-close', () => {
        if (this.mobileDialogOpen) {
          this.mobileDialogUsageCount--;
          this.mobileDialogOpen = this.mobileDialogUsageCount > 0;
          if (!this.mobileDialogOpen) EventBus.$emit('mobile-dialog-close-all');
        }
      });

      window.onpopstate = () => {
        if (this.mobileDialogOpen) {
          EventBus.$emit('mobile-dialog-close');
        }
      };
    }
  },

  beforeDestroy() {
    if (this.isMobile()) {
      EventBus.$off('mobile-dialog-open');
      EventBus.$off('mobile-dialog-close');
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.mobileDialogOpen && this.isMobile()) {
      EventBus.$emit('mobile-dialog-close-all');
      next(false);
    } else {
      next();
    }
  },
};
